
// 초기 설치
//
// @since 2018-09
// @author 강정규 ( devp012 )

import Moment from 'moment/moment'

export const state = () => ({
  urlInit: '/api/sm/init-setting',

  // STEP0. 장비 정보
  urlOperation: '/api/sm/info/operation',
  operInfo: {
    model: '',
    sw_version: '',
    hwserial: ''
  },

  // STEP3. 장비 이름 / 위치 / 설명
  urlEquipment: '/api/sm/info/equipment',
  countryOptions: [],

  // STEP3. 시스템 시간
  urlSystemTime: '/api/sm/info/time',

  // STEP4. 인터페이스
  urlInterfaces: '/api/sm/interfaces',
  interfaceOptions: [],

  initData: {
    license_file: '', // required (string) 라이선스 파일 이름
    user: { // required (object) 관리자 설정
      adm_id: '', //    (integer) ID
      login_id: '', //  (string - maxLength: 32) 로그인 ID
      login_pw: '', //  required (string - minLength: 9 - maxLength: 32) 비밀번호(Base64인코딩)(영문,숫자,특수문자 조합)
      name: '', //      (string - maxLength: 32) 이름
      depart: '', //    (string - maxLength: 32) 부서
      phone: '', //     (string - maxLength: 16) 연락처
      email: '' //      (string - maxLength: 256) 이메일
    },
    equipment: { // required (object) 장비 설정
      hostname: '', //  required (string) 장비 이름
      location: 'KR', //  (one of KR, ..., 국가코드)장비 위치 설정
      desc: '' //       (string) 장비 설명
    },
    time: { // required (object) 시간 설정
      type: 0, //           required (one of 0, 1) 설정 타입 (수동 설정: 0, NTP 설정: 1)
      now_clock: '', //     required (string) 수동 설정 시간
      ntp: { //             required (object) NTP 설정
        svr1: '', //        required (string) NTP 서버1 주소
        svr2: '', //        (string) NTP 서버2 주소
        interval: 1800, //  required (integer - default: 1800 - minimum: 10 - maximum: 14400) 업데이트 주기(초)
        mode: 2 //          required (one of 1, 2) 동작 방식 (slew: 1, step: 2)
      },
      tz_type: 1, // required (one of 1, 2) Timezone 설정 방식 (지역/도시: 1, Offset: 2)
      tz_data: '' // required (string) 지역/도시 또는 Offset
      //              Example: (T) 지역/도시 정보 (예시 : ‘America/Santiago’)
      //                       (O) offset 정보 (예시 : ‘+,1,1,1’)
    },
    interface: { // required (object) 인터페이스 설정
      id: '', //        required (integer) 인터페이스 ID
      name: '', //      required (string) 인터페이스 이름
      zone: 1, //       required (one of 0, 1, 2, 3, 4) Zone(None: 0, Internal: 1, External: 2, DMZ: 3, HA: 4)
      ip: '' //         required (string) 인터페이스 주소(IPv4 Address/Prefix)
    },
    gw: '', //  (string) 디폴트 게이트웨이(IPv4 Address)
    dns: [], // (array of ) DNS 서버
    //          Example: ["8.8.8.8","168.126.63.1"]
    admin_ip: '' // (string) 관리자 IP(IPv4 Address/Prefix[24~32])
  },
  step2Data: {
    admMode: 'chgPwd', // chgPwd: 비밀번호 변경, chgAdm: 관리자 변경
    password: '',
    rePassword: ''
    // selectedLang: 'KR'
  },
  step3Data: {
    tzOffset: '+',
    tzHour: 0,
    tzMin: 0,
    tzSec: 0,
    tzTimeZone: ''
  },
  step4Data: {
    interfaceIp: '',
    interfaceMask: '',
    adminIp: '',
    adminMask: '',
    dns1: '',
    dns2: ''
  }
})

export const mutations = {
  getInitOperationInfo (state, data) {
    state.operInfo.model = data.model
    state.operInfo.sw_version = data.sw_version
    state.operInfo.hwserial = data.hwserial
  },
  getInitSystemTime (state, data) {
    state.initData.time.type = data.type
    state.initData.time.now_clock = data.now_clock

    state.initData.time.ntp.svr1 = data.ntp.svr1
    state.initData.time.ntp.svr2 = data.ntp.svr2
    state.initData.time.ntp.interval = data.ntp.interval
    state.initData.time.ntp.mode = data.ntp.mode

    state.initData.time.tz_type = data.tz_type
    state.initData.time.tz_data = data.tz_data

    // 다이얼로그 데이터
    if (data.tz_type === 1) {
      state.step3Data.tzTimeZone = data.tz_data
    } else {
      const splitStr = data.tz_data.split(',')
      if (splitStr.length === 4) {
        state.step3Data.tzOffset = splitStr[0]
        state.step3Data.tzHour = Number(splitStr[1])
        state.step3Data.tzMin = Number(splitStr[2])
        state.step3Data.tzSec = Number(splitStr[3])
      }
    }

    state.timeZoneOptions = []
    for (const tz of data.tz_list) {
      state.timeZoneOptions.push({label: tz.comment, value: tz.timezone})
    }
  },
  getInitEquipment (state, data) {
    state.initData.equipment.hostname = data.hostname
    state.initData.equipment.location = data.location
    state.initData.equipment.desc = data.desc

    // 국가 리스트 생성
    state.countryOptions = []
    for (const country of data.country_list) {
      state.countryOptions.push({
        label: country.full,
        value: country.code
      })
    }
  },
  getInitInterfacesData (state, data) {
    state.interfaceOptions = []
    for (const item of data) {
      if (!_.isUndefined(item.mode.mode) && item.mode.mode === 1) { // L3 (mode===3) 만 가능
        state.interfaceOptions.push({
          label: item.name,
          value: item.id,
          ip: _.isUndefined(item.mode.static) ? '' : item.mode.static.ipv4
        })
      }
    }
  }
}

export const actions = {
  // STEP0. 장비 정보 조회
  async getInitOperationInfo ({commit, state}) {
    try {
      const {code, result} = await this.$axios.$get(state.urlOperation, {loadingShow: false, loadingHide: false})
      if (code === 'ok') {
        commit('getInitOperationInfo', result)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  },
  // STEP3. 장비 이름/위치/설명, 국가 리스트
  async getInitEquipment ({commit, state}) {
    try {
      const {code, result} = await this.$axios.$get(state.urlEquipment, {loadingShow: false, loadingHide: false})
      if (code === 'ok') {
        commit('getInitEquipment', result)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  },
  // STEP3. 시간 설정(NTP, TIMEZONE)
  async getInitSystemTime ({commit, state}) {
    try {
      const {code, result} = await this.$axios.$get(state.urlSystemTime, {loadingShow: false, loadingHide: false})
      if (code === 'ok') {
        commit('getInitSystemTime', result)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  },
  async getInitInterfacesData ({commit, state}) {
    try {
      const {code, result} = await this.$axios.$get(state.urlInterfaces, {loadingShow: false, loadingHide: false})
      if (code === 'ok') {
        commit('getInitInterfacesData', result)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  },
  async finalCommand ({state}) {
    const param = _.cloneDeep(state.initData)

    // 전달 데이터 가공
    if (state.step2Data.admMode === 'chgPwd') {
      // 1. 관리자 - '비밀번호 변경' 모드인 경우 login_id = ''
      delete param.user.login_id
      delete param.user.name
      delete param.user.depart
      delete param.user.phone
      delete param.user.email
    } else {
      // 2. 관리자 - '관리자 변경' 모드인 경우 adm_id = ''
      delete param.user.adm_id
    }
    // 3. password 설정
    param.user.login_pw = btoa(state.step2Data.password)

    // 4. Timezone 설정이 offset인 경우 문자열 가공
    if (param.time.tz_type === 1) {
      // 지역/도시
      param.time.tz_data = state.step3Data.tzTimeZone
    } else {
      // offset 정보 (예시 : ‘+,1,1,1’)
      param.time.tz_data = `${state.step3Data.tzOffset},${state.step3Data.tzHour},${state.step3Data.tzMin},${state.step3Data.tzSec}`
    }
    param.time.now_clock = Moment(param.time.now_clock).format('YYYY-MM-DD HH:mm:ss')

    // 5. DNS 서버 설정
    if (state.step4Data.dns1 !== '') {
      param.dns.push(state.step4Data.dns1)
    }
    if (state.step4Data.dns2 !== '') {
      param.dns.push(state.step4Data.dns2)
    }

    // 6. 인터페이스 설정 - IP
    if (state.step4Data.interfaceIp === '' || state.step4Data.interfaceMask === '') {
      param.interface.ip = ''
    } else {
      param.interface.ip = `${state.step4Data.interfaceIp}/${state.step4Data.interfaceMask}`
    }

    // 7. 디폴트 게이트웨이 - 관리자 접속 IP
    if (state.step4Data.adminIp === '' || state.step4Data.adminMask === '') {
      param.admin_ip = ''
    } else {
      param.admin_ip = `${state.step4Data.adminIp}/${state.step4Data.adminMask}`
    }

    const {code} = await this.$axios.$post(state.urlInit, param)
    if (code === 'ok') {
      return true
    }
    return false
  }
}

export const getters = {
  getTest () {
    return 1
  }
}

export const strict = false
